import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  educationList: [],
  educationFormList: [],
  educationDetail: [],
  loading: false,
  error: undefined,
};

const educationSlice = createSlice({
  name: "education",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchEducationList(state, action) {
      state.educationList = action.payload;
      state.loading = false;
    },
    fetchEducationFormList(state, action) {
      state.educationFormList = action.payload;
      state.loading = false;
    },
    fetchEducationDetail(state, action) {
      state.educationDetail = action.payload;
      state.loading = false;
    },
  },
});

export const educationActions = educationSlice.actions;

export default educationSlice.reducer;
